module.exports = __webpack_public_path__ + "static/media/thailand-gray.3853990f.svg";